/** @format */

import { TPermission } from "../declarations/maps/permissions";
import { TStore } from "../declarations/store";

export const selectorPermissionList = (store: TStore): TPermission[] =>
  store.permissions.permissionList || [];
